"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _sizes = require("HubStyleTokens/sizes");

var _colors = require("HubStyleTokens/colors");

var _UIIcon = _interopRequireDefault(require("../../icon/UIIcon"));

var _Styles = require("../../utils/Styles");

var _Dom = require("../../utils/Dom");

var getFontSize = function getFontSize(size) {
  if (typeof size === 'number') return size;
  return parseInt(size === 'small' ? _sizes.INPUT_SM_FONT_SIZE : _sizes.INPUT_FONT_SIZE, 10);
};

var InputWrapper = _styledComponents.default.div.withConfig({
  displayName: "UIInputIconWrapper__InputWrapper",
  componentId: "sc-1c956zh-0"
})(["position:relative;&& input{padding-left:", ";}"], function (_ref) {
  var inFloatingForm = _ref.inFloatingForm,
      size = _ref.size;
  return (0, _Styles.toPx)((inFloatingForm ? 6 : parseInt(_sizes.INPUT_DEFAULT_PADDING_X, 10) * 2) + getFontSize(size));
});

var IconWrapper = _styledComponents.default.div.withConfig({
  displayName: "UIInputIconWrapper__IconWrapper",
  componentId: "sc-1c956zh-1"
})(["display:flex;align-items:center;position:absolute;top:0;bottom:0;left:0;padding:", ";pointer-events:none;z-index:", ";"], function (_ref2) {
  var inFloatingForm = _ref2.inFloatingForm;
  return inFloatingForm ? '6px 0 0' : "0 " + _sizes.INPUT_DEFAULT_PADDING_X;
}, _sizes.VENUS_LAYER);

var Icon = (0, _styledComponents.default)(_UIIcon.default).withConfig({
  displayName: "UIInputIconWrapper__Icon",
  componentId: "sc-1c956zh-2"
})(["transform:translateY(1px);"]);

var UIInputIconWrapper = function UIInputIconWrapper(props) {
  var children = props.children,
      className = props.className,
      disabled = props.disabled,
      iconName = props.iconName,
      size = props.size,
      rest = (0, _objectWithoutProperties2.default)(props, ["children", "className", "disabled", "iconName", "size"]);
  var inFloatingForm = (0, _Dom.listAttrIncludes)(className, 'private-form__control--inline');
  var computedSize = inFloatingForm ? 14 : getFontSize(size);
  return _react.default.createElement(InputWrapper, Object.assign({}, rest, {
    className: className,
    inFloatingForm: inFloatingForm,
    size: computedSize
  }), children, _react.default.createElement(IconWrapper, {
    inFloatingForm: inFloatingForm
  }, _react.default.createElement(Icon, {
    name: iconName,
    color: disabled ? _colors.BATTLESHIP : undefined,
    size: computedSize
  })));
};

if (process.env.NODE_ENV !== 'production') {
  UIInputIconWrapper.propTypes = {
    align: _propTypes.default.oneOf(['left', 'right']).isRequired,
    disabled: _propTypes.default.bool,
    children: _propTypes.default.node,
    iconName: _UIIcon.default.propTypes.name,
    size: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['default', 'small'])]).isRequired
  };
}

UIInputIconWrapper.defaultProps = {
  align: 'left'
};
UIInputIconWrapper.displayName = 'UIInputIconWrapper';
var _default = UIInputIconWrapper;
exports.default = _default;
module.exports = exports.default;